<template>
  <v-dialog persistent="" :model-value="dialog" width="auto">
    <v-card
      flat
      width="400"
      :style="{
        borderBottom: '3px solid #272727',
        borderLeft: '1px solid #272727',
        borderTop: '1px solid #272727',
        borderRight: '3px solid #272727',
      }"
    >
      <v-sheet
        class="d-flex justify-center align-center py-2"
        color="accent"
        style="font-size: 10pt; font-weight: 600"
      >
        Import post
      </v-sheet>
      <v-divider class="primary"></v-divider>
      <div class="pa-6">
        <div>
          <p style="font-size: 10pt" class="mb-2">Recurring:</p>
          <v-select
            label="Recurring"
            v-model="recurring"
            no-data-text="No categories setup"
            item-color="button darken-2"
            bg-color="smoke"
            variant="solo"
            class="mb-2"
            flat
            density="comfortable"
            style="border-radius: 5px; font-size: 10pt"
            :items="[
              {
                title: 'Recurring',
                value: true,
              },
              {
                title: 'One-time',
                value: false,
              },
            ]"
            hide-details=""
            :menu-props="{ offsetY: true }"
          >
            <template v-slot:item="{ props }">
              <v-list-item
                v-bind="props"
                :prepend-icon="
                  props.value ? 'mdi-leaf' : 'mdi-numeric-1-circle'
                "
                :title="props.title"
              >
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <div
                class="d-flex align-center"
                style="width: 100%; font-size: 10pt"
              >
                <v-icon
                  size="small"
                  class="mr-2"
                  v-if="item.value"
                  color="green"
                  >mdi-leaf</v-icon
                >
                <v-icon
                  size="small"
                  class="mr-2"
                  v-if="!item.value"
                  color="primary"
                  >mdi-numeric-1-circle</v-icon
                >
                {{ item.title }}
              </div>
            </template>
          </v-select>
        </div>
        <div>
          <p style="font-size: 10pt" class="mb-2">Account:</p>
          <v-select
            :items="accounts"
            :loading="loading.accounts"
            item-title="name"
            item-value="id"
            class="mb-2"
            variant="solo"
            flat
            bg-color="smoke"
            multiple=""
            hide-details=""
            item-props=""
            label="Accounts"
            v-model="selected_accounts"
          >
            <template v-slot:item="{ props }">
              <v-list-item
                v-bind="props"
                :prepend-avatar="
                  props.profile_picture.src
                    ? props.profile_picture.src
                    : props.profile_picture
                "
                :title="props.name"
              >
                <template v-slot:prepend>
                  <v-avatar
                    :image="
                      props.profile_picture.src
                        ? props.profile_picture.src
                        : props.profile_picture
                    "
                    size="25"
                    class="mr-2"
                  >
                  </v-avatar>
                </template>

                <template v-slot:append>
                  <v-avatar
                    :image="require(`@/assets/${props.platform}.png`)"
                    tile
                    size="20"
                  >
                  </v-avatar
                ></template>
              </v-list-item>
            </template>
          </v-select>
        </div>
        <div>
          <p style="font-size: 10pt" class="mb-2">Category:</p>
          <v-select
            :items="categories"
            :loading="loading.categories"
            item-title="name"
            item-value="uid"
            variant="solo"
            hide-details=""
            class="mb-2"
            flat
            bg-color="smoke"
            label="Category"
            item-props=""
            v-model="selected_category"
          ></v-select>
        </div>
      </div>
      <v-divider></v-divider>

      <template v-slot:actions>
        <v-btn text="Close" @click="$emit('close')"></v-btn>
        <v-spacer></v-spacer>
        <v-btn text="Add" variant="flat" @click="add" color="success"></v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      workspace: (state) => state.workspace.workspace,
      accounts: (state) => state.accounts.accounts,
      loading: (state) => state.loading,
      categories: (state) => state.posts.categories,
    }),
  },
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      recurring: true,
      draft: true,
      selected_accounts: [],
      selected_category: null,
    };
  },
  methods: {
    add() {
      this.$emit("add", {
        recurring: this.recurring,
        accounts: this.selected_accounts,
        status: this.draft ? "draft" : "active",
        category: this.selected_category,
      });
    },
  },
};
</script>
